import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Box, Typography, Grid, Pagination, Container, Card, Tooltip, Button, CardContent, Divider, CircularProgress, Modal } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Avatar from '@mui/material/Avatar';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import LinearProgress from '@mui/material/LinearProgress';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LeadLogo from '../../../../public/assets/logo_between.png';
import DateRangeIcon from '@mui/icons-material/DateRange';
import ScrollAnimation from 'react-animate-on-scroll';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import axios from 'axios';
import PhoneIcon from '@mui/icons-material/Phone';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { GoogleMap, DirectionsService, DirectionsRenderer, useLoadScript, Marker, OverlayView } from '@react-google-maps/api';
import LeadService from '../../../core/services/leadsService';
import LogoutExpiredModal from '../../LogoutExpiredModal';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import InfoIcon from "@mui/icons-material/Info";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
const libraries = ['directions'];

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '22px',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    width: '558px',
    height: 'auto',
    overflow: 'auto',
};

const ICAAlerts = () => {
    const navigate = useNavigate();
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [getNotification, setGetNotification] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');
    const [selectedAlertValue, setSelectedAlertValue] = useState('');
    const [IsSuccess, SetIsSuccess] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingDetails, setIsLoadingDetails] = useState(false);
    const [agentLatLng, setAgentLatLng] = useState(null);
    const [leadLatLng, setLeadLatLng] = useState(null);
    const [directions, setDirections] = useState(null);
    const [duration, setDuration] = useState('');
    const [distance, setDistance] = useState('');
    const [agentAddress, setAgentAddress] = useState(null);
    const [previousAgentLatLng, setPreviousAgentLatLng] = useState(null);
    const [previousLeadLatLng, setPreviousLeadLatLng] = useState(null);
    const [logOutModal, setLogOutModal] = React.useState(false);
    const [deletedId, setDeletedId] = useState(null);
    const [deletedPenaltyId, setDeletedPenaltyId] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [isOpenMeeting, setIsOpenMeeting] = useState(false);
    const [openDialogPenalty, setOpenDialogPenalty] = useState(false);
    const [isOpenPenalty, setIsOpenPenalty] = useState(false);
    const [isOpenHalfBamfam, setIsOpenHalfBamfam] = useState(false);
    const [isOpenAppointment, setIsOpenAppointment] = useState(false);
    const [isOpenChangedAppointment, setIsOpenChangedAppointment] = useState(false);
    const intervalRef = useRef(null);
    const isFirstCallRef = useRef(true);
    const options = [
        { label: 'All', value: '' },
        { label: 'Minimum Time', value: 'min' },
        { label: 'Maximum Time', value: 'max' },
    ];
    const AlertType = [
        { label: 'All', value: '' },
        { label: 'penalty Alerts', value: 'penalty' },
        { label: 'Half-Bamfam Alerts', value: 'halfbamfam' },
        { label: 'Meeting Alerts', value: 'meeting_alert' },
        { label: 'Changed Appointment', value: 'changed_appointment' },
        { label: 'Half Appointment', value: 'half_appointment' },
    ];
    const HandleChangeLastLogin = async (event, newValue) => {
        setSelectedValue(newValue ? newValue.value : '');
    };
    const HandleChangeAlertType = async (event, newValue) => {
        setSelectedAlertValue(newValue ? newValue.value : '');
    };
    const fetchAddressFromLatLong = async (latitude, longitude) => {
        try {
            const response = await axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
                params: {
                    latlng: `${latitude},${longitude}`,
                    key: 'AIzaSyCkMAzfTYAjsRE0zZoITa3ktRqd00zLksU',
                },
            });
            if (response.data.results?.length) {
                return response.data.results[0].formatted_address;
            }
            return 'Address not found';
        } catch (error) {
            console.error('Error fetching address:', error);
            return 'Error fetching address';
        }
    };
    const ICAAlerts = useCallback(
        async (isFirstCall) => {
            try {
                if (isFirstCall) {
                    setIsLoadingDetails(true);
                }
                const res = await LeadService.getIcaAlerts(selectedValue, selectedAlertValue);
                if (res?.data?.success) {
                    SetIsSuccess(res?.data?.success);
                    const notifications = await Promise.all(
                        res?.data?.data.map(async (alert) => {
                            const { latitude, longitude } = alert.agent;
                            const address = await fetchAddressFromLatLong(latitude, longitude); // Fetch address
                            return { ...alert, address }; // Include address in each alert
                        })
                    );
                    setGetNotification(notifications);
                    setIsLoadingDetails(false);
                }
            } catch (error) {
                if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                    setLogOutModal(true);
                } else {
                    toast.error(error.message);
                }
            } finally {
                setIsLoadingDetails(false);
                setIsLoading(false);
            }
        },
        [selectedValue, selectedAlertValue]
    );
    useEffect(() => {
        ICAAlerts(isFirstCallRef.current);
        isFirstCallRef.current = false;

        intervalRef.current = setInterval(() => {
            ICAAlerts(false);
        }, 120000);

        return () => clearInterval(intervalRef.current);
    }, [ICAAlerts]);
    const getAgentAddress = useCallback(async (lat, lng) => {
        try {
            const geocoder = new window.google.maps.Geocoder();
            const location = { lat: parseFloat(lat), lng: parseFloat(lng) };

            geocoder.geocode({ location }, (results, status) => {
                if (status === 'OK') {
                    if (results[0]) {
                        setAgentAddress(results[0].formatted_address);
                    } else {
                        console.error('No results found');
                    }
                } else {
                    console.error('Geocoder failed due to: ' + status);
                }
            });
        } catch (error) {
            console.error('Error finding agent location:', error);
        }
    }, []);

    useEffect(() => {
        if (agentLatLng && (!previousAgentLatLng || agentLatLng.lat !== previousAgentLatLng.lat || agentLatLng.lng !== previousAgentLatLng.lng)) {
            getAgentAddress(agentLatLng.lat, agentLatLng.lng);

            // Save the lat/lng for future comparison
            setPreviousAgentLatLng(agentLatLng);
        }
    }, [agentLatLng, previousAgentLatLng, getAgentAddress]);

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: 'AIzaSyCkMAzfTYAjsRE0zZoITa3ktRqd00zLksU',
        libraries,
    });

    useEffect(() => {
        if (
            isLoaded &&
            agentLatLng !== null &&
            leadLatLng !== null &&
            (!previousAgentLatLng ||
                !previousLeadLatLng ||
                agentLatLng.lat !== previousAgentLatLng.lat ||
                agentLatLng.lng !== previousAgentLatLng.lng ||
                leadLatLng.lat !== previousLeadLatLng.lat ||
                leadLatLng.lng !== previousLeadLatLng.lng)
        ) {
            const directionsService = new window.google.maps.DirectionsService();
            const request = {
                origin: agentLatLng,
                destination: leadLatLng,
                travelMode: 'DRIVING',
            };
            directionsService.route(request, (response, status) => {
                if (status === 'OK') {
                    setDuration(response.routes[0].legs[0].duration.text);
                    setDistance(response.routes[0].legs[0].distance.text);
                    setDirections(response);

                    // Save the new lat/lng for comparison on the next update
                    setPreviousAgentLatLng(agentLatLng);
                    setPreviousLeadLatLng(leadLatLng);
                } else {
                    console.error('Error fetching directions:', status);
                }
            });
        }
    }, [isLoaded, agentLatLng, leadLatLng, previousAgentLatLng, previousLeadLatLng]);

    const HandleNavigateToLeadDetails = (lead_id) => {
        const AlertView = 'Alerts_View';
        navigate(`/admin-leads-details/${lead_id}`, { state: { AlertView: AlertView } });
    };

    const adjustTimeBasedOnOffsetForReceivedData = (date, offsetInHours) => {
        const adjustedDate = new Date(date);
        adjustedDate.setHours(adjustedDate.getHours() + offsetInHours);
        return adjustedDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');

        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        hours = String(hours).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
    };

    const mapStatusToFormatAndColor = (status) => {
        const statusMapping = {
            active: { text: ' ● New ', color: '#00000F' },
            new: { text: ' ● New ', color: '#00000F' },
            attempting_contact: { text: ' ● Attempting Contact ', color: '#9B0000' },
            spoke_with_customer_new: { text: ' ● New ', color: '#00000F' },
            spoke_with_customer: { text: ' ● Spoke with customer ', color: '#00BF2A' },
            appointment_set: { text: ' ● Appointment Set ', color: '#00BF2A' },
            met_with_customer: { text: ' ● Met with customer ', color: '#7400C2' },
            showing_homes: { text: ' ● Showing Homes ', color: '#ED7DB1' },
            submitting_offers: { text: ' ● Submitting Offers ', color: '#6EA478' },
            under_contract_escrow: { text: ' ● Under Contract/Escrow ', color: '#4C489B' },
            bamfam: { text: ' ● BAMFAM ', color: '#6691CB' },
            nurture: { text: ' ● Nurture Before sale ', color: '#9B5B00' },
            nurture_after_sale: { text: ' ● Nurture After Sale ', color: '#9B5B5B' },
            closed: { text: ' ●  Sale Closed ', color: '#F17105' },
            rejected: { text: ' ● Rejected ', color: '#ED0423' },
            not_interested: { text: ' ● Not Interested ', color: '#ebc3c3' },
            refinance_referral: { text: ' ● Refinance Referral ', color: '#9B5B5B' },
            personal_lead: { text: ' ● Personal Lead ', color: '#9B5B5B' },
            agent: { text: ' ● Agent ', color: 'white' },
            bad_lead: { text: ' ● Bad Lead ', color: '#2e1414' },
            buy_side_contract: { text: ' ● Buy Side Contract ', color: '#9B5B5B' },
            dnc: { text: ' ● DNC ', color: '#9B5B5B' },
            buyer_broker_signed: { text: ' ● Buyer Broker Signed ', color: '#FFFFFF' },
            cancelled: { text: ' ● Cancelled ', color: '#FFFFFF' },
            valuation_appointment: { text: ' ● Valuation Appointment ', color: '#FFFFFF' },
            listing_signed: { text: ' ● Listing Signed ', color: '#FFFFFF' },
            listing_appointment: { text: ' ● Listing Appointment ', color: '#FFFFFF' },
            follow_up: { text: ' ● Follow Up ', color: '#FFFFFF' },
            list_under_contract: { text: ' ● List Under Contract ', color: 'black' },
        };

        const divBackgroundColors = {
            active: '#e9e4e4',
            new: '#e9e4e4',
            attempting_contact: '#ababef',
            spoke_with_customer_new: '#ababef',
            spoke_with_customer: '#bee5c6',
            appointment_set: '#bee5c6',
            met_with_customer: '#d9c2e9',
            showing_homes: '#f9d5e6',
            submitting_offers: '#bbe3c2',
            under_contract_escrow: '#c1bfed',
            bamfam: '#edeff5',
            nurture: '#f9deb8',
            nurture_after_sale: '#e7c612',
            closed: '#fff0e3',
            rejected: '#fbdfe2',
            not_interested: '#df3271',
            refinance_referral: '#e7e2c7',
            agent: '#5500CC',
            personal_lead: '##fff',
            bad_lead: '#c12f0d',
            buy_side_contract: '#e7c612',
            dnc: '#A87BFF',
            buyer_broker_signed: '#FABED4',
            cancelled: '#4C489B',
            valuation_appointment: '#7D9B00',
            listing_signed: '#C29800',
            listing_appointment: '#CB5935',
            follow_up: '#2e7a5c',
            list_under_contract: '#937474',
        };
        const divBorder = {
            active: '1px solid black',
            new: '1px solid black',
            attempting_contact: '1px solid #9B0000',
            spoke_with_customer_new: '1px solid #00000F',
            spoke_with_customer: '1px solid #00BF2A',
            appointment_set: '1px solid #00BF2A',
            met_with_customer: '1px solid #7400C2',
            showing_homes: '1px solid #ED7DB1',
            submitting_offers: '1px solid #6EA478',
            under_contract_escrow: '1px solid #4C489B',
            bamfam: '1px solid #6691CB',
            nurture: '1px solid #9B5B00',
            nurture_after_sale: '1px solid #9B5B5B',
            closed: '1px solid #F17105',
            rejected: '1px solid #ED0423',
            not_interested: '1px solid #a9199f',
            refinance_referral: '1px solid #a99497',
            agent: '1px solid #5500CC',
            personal_lead: '1px solid #a99497',
            bad_lead: '1px solid #5c433b',
            buy_side_contract: '1px solid #9B5B5B',
            dnc: '1px solid #9B5B5B',
            buyer_broker_signed: '1px solid #FABED4',
            cancelled: '1px solid #4C489B',
            valuation_appointment: '1px solid #7D9B00',
            listing_signed: '1px solid #483c10',
            listing_appointment: '1px solid #CB5935',
            follow_up: '1px solid #2d6f55',
            list_under_contract: '1px solid #2d6f55',
        };

        const { text, color } = statusMapping[status] || { text: status, color: '#000000' };
        const divBackgroundColor = divBackgroundColors[status] || 'transparent';
        const border = divBorder[status] || '1px solid black';
        return {
            formattedStatus: <span style={{ color }}>{text}</span>,
            divStyle: {
                background: divBackgroundColor,
                border,
            },
        };
    };
    const { formattedStatus, divStyle } = mapStatusToFormatAndColor(getNotification?.lead?.status);

    const handleDeletePenalty = async (penalty_id) => {
        setDeletedPenaltyId(penalty_id);
        setOpenDialogPenalty(true);
    };
    const handleClickClose = () => {
        setOpenDialog(false);
        setOpenDialogPenalty(false);
    };
    const handlePromptMessageDeleted = async (deletedId) => {
        try {
            setDeleteLoading(true);
            const res = await LeadService.DeleteAlerts(deletedId);
            if (res?.data?.success) {
                toast.success(res?.data?.message);
                ICAAlerts(selectedValue, selectedAlertValue);
                setDeletedId(null);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setDeleteLoading(false);
            setOpenDialog(false);
        }
    };

    const handlePenaltyDeleted = async (deletedPenaltyId) => {
        try {
            setDeleteLoading(true);
            const res = await LeadService.adminDeletePenalty(deletedPenaltyId);
            if (res?.data?.success) {
                toast.success(res?.data?.message);
                AdminNotifications(selectedValue, selectedAlertValue);
                setDeletedPenaltyId(null);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setDeleteLoading(false);
            setOpenDialogPenalty(false);
        }
    };

    return (
        <>
            <Container>
                <div style={{ marginBottom: '15px' }}>{isLoadingDetails && <LinearProgress />} </div>
                <>
                    <Box style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '14px', gap: '8px' }}>
                        <Autocomplete
                            options={AlertType}
                            getOptionLabel={(AlertType) => AlertType.label}
                            renderInput={(params) => <TextField {...params} label="Alert Type" />}
                            sx={{ width: 300 }}
                            value={AlertType?.find((AlertType) => AlertType?.value === selectedAlertValue) || null}
                            onChange={HandleChangeAlertType}
                            disabled={isLoading}
                        />
                        {selectedAlertValue === 'meeting_alert' && (
                            <Autocomplete
                                options={options}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => <TextField {...params} label="Time" />}
                                sx={{ width: 300 }}
                                value={options?.find((option) => option.value === selectedValue) || null}
                                onChange={HandleChangeLastLogin}
                                disabled={isLoading}
                            />
                        )}
                    </Box>

                    {/* {IsSuccess === true && getNotification.length === 0 ? (
                        <p style={{ fontWeight: 'bold', textAlign: 'center' }}>No data found!</p>
                    ) : ( */}
                    <>
                        <Grid container spacing={2}>
                            {/* {getNotification && ( */}
                            <>
                                {/* Filter and show meeting alerts */}
                                {/* {getNotification?.some((alert) => alert?.notify_for === 'meeting_alert') && ( */}
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Box
                                        style={{
                                            marginTop: '10px',
                                            height: '80px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            backgroundColor: 'White',
                                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                            borderRadius: '10px',
                                            padding: '0 16px',
                                        }}
                                    >

                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            <Tooltip title="Trigger meeting alerts when an agent is away from the customer or lead location with only one hour left" arrow>
                                                <InfoIcon style={{ cursor: 'pointer', color: '#1976d2' }} />
                                            </Tooltip>
                                        </Box>


                                        <Box style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
                                            <Typography
                                                style={{
                                                    fontSize: '22px',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                Meeting Alerts
                                            </Typography>
                                        </Box>
                                        <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            {/* Expand/Collapse Toggle */}
                                            <IconButton onClick={() => setIsOpenMeeting(!isOpenMeeting)}>
                                                {isOpenMeeting ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </IconButton>
                                        </Box>
                                    </Box>
                                </Grid>
                                {/* )} */}
                                {isOpenMeeting && getNotification
                                    ?.filter((alert) => alert?.notify_for === 'meeting_alert')
                                    ?.map((alert) => (
                                        <Card
                                            key={alert?.id}
                                            sx={{
                                                width: {
                                                    xs: '100%',
                                                    sm: '47%',
                                                    md: '48%',
                                                },
                                                height: 'auto',
                                                margin: '10px',
                                                transform: 'scale(1)',
                                                transition: 'transform 0.3s ease-in-out',
                                                borderRadius: '16px',
                                                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                '&:hover': { transform: 'scale(1.02)' },
                                                padding: '16px',
                                                backgroundColor: '#FFFFFF',
                                                cursor: 'pointer',
                                            }}
                                            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                                            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                                        >
                                            <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '5px' }}>
                                                <Button
                                                    onClick={() => HandleNavigateToLeadDetails(alert?.lead_id)}
                                                    style={{
                                                        color:
                                                            alert?.time === '15'
                                                                ? '#df3f3f' // Light red
                                                                : alert?.time === '30'
                                                                    ? '#f8b657' // Light orange
                                                                    : alert?.time === '45'
                                                                        ? '#6695a4' // Light blue
                                                                        : alert?.time === '60'
                                                                            ? '#90EE90' // Light green
                                                                            : '#000000', // Default black for unknown time
                                                    }}
                                                >
                                                    View Details
                                                </Button>
                                            </Box>
                                            <CardContent
                                                style={{
                                                    borderRadius: '12px',
                                                    background:
                                                        alert?.time === '15'
                                                            ? '#ed8686' // Light red
                                                            : alert?.time === '30'
                                                                ? '#f2c079' // Light orange
                                                                : alert?.time === '45'
                                                                    ? '#92becb' // Light blue
                                                                    : alert?.time === '60'
                                                                        ? '#90EE90' // Light green
                                                                        : '#fff', // Default black for unknown time
                                                }}
                                            >
                                                <Grid container spacing={2}>
                                                    {/* Left Section */}
                                                    <Grid item xs={5} sm={5} md={5}>
                                                        <Box style={{ display: 'grid', justifyContent: 'center' }} mb={2}>
                                                            <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                                <Avatar
                                                                    alt={alert?.agent?.name}
                                                                    src={`https://iconnctapp.com/` + alert?.agent?.profile_image}
                                                                    sx={{ width: 100, height: 100, mr: 2 }}
                                                                />
                                                            </Box>
                                                            <Box style={{ marginTop: '10px' }}>
                                                                <Typography style={{ fontSize: '21px', fontWeight: 'bold' }}>
                                                                    {alert?.agent?.name} {alert?.agent?.last_name}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                        <Box style={{ display: 'grid', gap: '10px' }}>
                                                            <div style={{ display: 'flex', gap: '4px' }}>
                                                                <EmailIcon fontSize="small" />
                                                                <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                                                    {' '}
                                                                    {alert?.agent?.email}
                                                                </Typography>
                                                            </div>
                                                            {alert?.agent?.phone && (
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <PhoneIcon />
                                                                    <Typography variant="body2"> {alert?.agent?.phone}</Typography>
                                                                </div>
                                                            )}
                                                            {distance === '' || duration === '' ? null : (
                                                                <>
                                                                    <Box
                                                                        style={{
                                                                            display: 'flex',
                                                                            justifyContent: 'center',
                                                                            marginTop: '5px',
                                                                            marginLeft: '-5px',
                                                                            background: '#dbd9d9',
                                                                            borderRadius: '12px',
                                                                            padding: '4px',
                                                                            width: '100%',
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            style={{
                                                                                display: 'flex',
                                                                                fontSize: '14px',
                                                                                color: '#252F46CC',
                                                                                fontWeight: '600',
                                                                            }}
                                                                        >
                                                                            Current distance: {distance},
                                                                        </Typography>
                                                                        <Box style={{ display: 'flex', gap: '1px', alignItems: 'center' }}>
                                                                            <Typography
                                                                                style={{
                                                                                    fontSize: '14px',
                                                                                    color: '#252F46CC',
                                                                                    fontWeight: '600',
                                                                                }}
                                                                            >
                                                                                {duration} away
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </>
                                                            )}
                                                            <div style={{ display: 'flex', gap: '4px' }}>
                                                                <LocationOnIcon fontSize="small" />
                                                                <Typography variant="body2"> {alert.address || ''} </Typography>
                                                            </div>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} display="flex" justifyContent="center" alignItems="center">
                                                        <Divider orientation="vertical" flexItem />
                                                    </Grid>
                                                    {/* Right Section */}
                                                    <Grid item xs={5} sm={5} md={5} style={{ position: 'relative' }}>
                                                        <Box style={{ display: 'grid', justifyContent: 'center' }} mb={2}>
                                                            <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                                <Avatar
                                                                    alt="Lead Avatar"
                                                                    src={
                                                                        alert?.ica_agent?.profile_image
                                                                            ? `https://iconnctapp.com/${alert?.ica_agent?.profile_image}`
                                                                            : LeadLogo
                                                                    }
                                                                    sx={{ width: 100, height: 100, mr: 2 }}
                                                                />
                                                            </Box>
                                                            <Box style={{ marginTop: '10px' }}>
                                                                <Typography style={{ fontSize: '21px', fontWeight: 'bold' }}>
                                                                    {alert?.lead?.first_name} {alert?.lead?.last_name}
                                                                </Typography>
                                                            </Box>
                                                        </Box>

                                                        <Box style={{ display: 'grid', gap: '10px' }}>
                                                            <div style={{ display: 'flex', gap: '4px' }}>
                                                                <EmailIcon fontSize="small" />
                                                                <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                                                    {alert?.lead?.email}
                                                                </Typography>
                                                            </div>
                                                            {alert?.lead?.phone && (
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <PhoneIcon fontSize="small" />
                                                                    <Typography variant="body2"> {alert?.lead?.phone}</Typography>
                                                                </div>
                                                            )}
                                                            <div style={{ display: 'flex', gap: '4px' }}>
                                                                <Typography style={{ fontSize: '16px', fontWeight: 'bold' }}>ICA:</Typography>
                                                                <Typography variant="body2">
                                                                    {alert?.ica_agent?.name} {alert?.ica_agent?.last_name}
                                                                </Typography>
                                                            </div>
                                                        </Box>
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={12}>
                                                        <Divider />
                                                    </Grid>
                                                    {/* Footer Information */}
                                                    <Grid item xs={12} sm={12} md={12}>
                                                        <Box>
                                                            <Grid container spacing={0.5}>
                                                                <Grid item xs={12} sm={12} md={12}>
                                                                    <div style={{ display: 'flex', gap: '5px' }}>
                                                                        <Avatar
                                                                            sx={{
                                                                                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                                                bgcolor: '#fff',
                                                                            }}
                                                                        >
                                                                            <AccessibilityIcon style={{ color: 'black' }} />
                                                                        </Avatar>
                                                                        <div style={{ marginTop: '10px', display: 'flex', gap: '4px' }}>
                                                                            <Typography style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                                                ICA:{' '}
                                                                            </Typography>
                                                                            <Typography style={{ fontSize: '15px' }}>
                                                                                {alert?.ica_agent?.name} {alert?.ica_agent?.last_name}
                                                                            </Typography>
                                                                        </div>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item xs={12} sm={12} md={12}>
                                                                    <div style={{ display: 'flex', gap: '5px' }}>
                                                                        <Avatar
                                                                            sx={{
                                                                                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                                                bgcolor: '#fff',
                                                                            }}
                                                                        >
                                                                            <AccessTimeFilledIcon style={{ color: 'black' }} />
                                                                        </Avatar>
                                                                        <div style={{ marginTop: '10px', display: 'flex', gap: '4px' }}>
                                                                            <Typography style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                                                Meeting In:
                                                                            </Typography>
                                                                            <Typography style={{ fontSize: '15px' }}>
                                                                                {alert?.time} minutes
                                                                            </Typography>
                                                                        </div>
                                                                    </div>
                                                                </Grid>
                                                                <Grid item xs={12} sm={12} md={12}>
                                                                    <div style={{ display: 'flex', gap: '5px' }}>
                                                                        <Avatar
                                                                            sx={{
                                                                                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                                                bgcolor: '#fff',
                                                                            }}
                                                                        >
                                                                            <LocationOnIcon style={{ color: 'black' }} />
                                                                        </Avatar>
                                                                        <div style={{ marginTop: '10px', display: 'flex', gap: '4px' }}>
                                                                            <Typography style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                                                Destination:{' '}
                                                                            </Typography>
                                                                            <Typography style={{ fontSize: '15px' }}>
                                                                                {alert?.lead?.display_address}
                                                                            </Typography>
                                                                        </div>
                                                                    </div>
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    ))}
                                {/* Filter and show admin penalty alerts */}
                                {/* {getNotification?.some((alert) => alert?.notify_for === 'admin_penalty') && ( */}
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Box
                                        style={{
                                            marginTop: '10px',
                                            height: '80px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            backgroundColor: 'White',
                                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                            borderRadius: '10px',
                                            padding: '0 16px',
                                        }}
                                    >
                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            <Tooltip title="Alerts in which agent didn't update the status of the lead will be shown here." arrow>
                                                <InfoIcon style={{ cursor: 'pointer', color: '#1976d2' }} />
                                            </Tooltip>
                                        </Box>

                                        <Box style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
                                            <Typography
                                                style={{
                                                    fontSize: '22px',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                Penalty Alerts
                                            </Typography>
                                        </Box>
                                        <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            {/* Expand/Collapse Toggle */}
                                            <IconButton onClick={() => setIsOpenPenalty(!isOpenPenalty)}>
                                                {isOpenPenalty ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </IconButton>
                                        </Box>
                                    </Box>
                                </Grid>
                                {/* )} */}

                                {isOpenPenalty &&
                                    getNotification
                                        ?.filter((alert) => alert?.notify_for === 'admin_penalty')
                                        ?.map((alert) => {
                                            const { formattedStatus, divStyle } = mapStatusToFormatAndColor(alert?.lead?.status);
                                            return (
                                                // new card
                                                <Card
                                                    key={alert?.id}
                                                    sx={{
                                                        width: {
                                                            xs: '100%',
                                                            sm: '47%',
                                                            md: '48%',
                                                        },
                                                        height: 'auto',
                                                        margin: '10px',
                                                        transform: 'scale(1)',
                                                        transition: 'transform 0.3s ease-in-out',
                                                        borderRadius: '16px',
                                                        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                        '&:hover': { transform: 'scale(1.02)' },
                                                        padding: '16px',
                                                        backgroundColor: '#FFFFFF',
                                                        cursor: 'pointer',
                                                    }}
                                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                                                >
                                                    <Grid container spacing={2}>
                                                        {/* Left Section */}
                                                        <Grid item xs={5} sm={5} md={5}>
                                                            <Box style={{ display: 'grid', justifyContent: 'center' }} mb={2}>
                                                                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <Avatar
                                                                        alt={alert?.agent?.name}
                                                                        src={`https://iconnctapp.com/` + alert?.agent?.profile_image}
                                                                        sx={{ width: 100, height: 100, mr: 2 }}
                                                                    />
                                                                </Box>
                                                                <Box style={{ marginTop: '10px' }}>
                                                                    <Typography style={{ fontSize: '21px', fontWeight: 'bold' }}>
                                                                        {alert?.agent?.name} {alert?.agent?.last_name}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                            <Box style={{ display: 'grid', gap: '10px' }}>
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <EmailIcon fontSize="small" />
                                                                    <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                                                        {' '}
                                                                        {alert?.agent?.email}
                                                                    </Typography>
                                                                </div>
                                                                {alert?.agent?.phone && (
                                                                    <div style={{ display: 'flex', gap: '4px' }}>
                                                                        <PhoneIcon />
                                                                        <Typography variant="body2"> {alert?.agent?.phone}</Typography>
                                                                    </div>
                                                                )}
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <LocationOnIcon fontSize="small" />
                                                                    <Typography variant="body2"> {alert.address || ''} </Typography>
                                                                </div>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={2} sm={2} md={2} display="flex" justifyContent="center" alignItems="center">
                                                            <Divider orientation="vertical" flexItem />
                                                        </Grid>
                                                        {/* Right Section */}
                                                        <Grid item xs={5} sm={5} md={5} style={{ position: 'relative' }}>
                                                            {/* Positioned IconButton */}
                                                            <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-10px' }}>
                                                                <Button
                                                                    onClick={() => HandleNavigateToLeadDetails(alert?.lead_id)}

                                                                >
                                                                    View Details
                                                                </Button>
                                                            </Box>
                                                            <IconButton
                                                                aria-label="delete"
                                                                color="error"
                                                                style={{ position: 'absolute', top: 30, right: 0 }}
                                                                onClick={() => handleDeletePenalty(alert?.penalty?.id)}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                            {/* <Tooltip title="Info" arrow>
                                                                        <IconButton
                                                                            onClick={() => HandleNavigateToLeadDetails(alert?.lead?.id)}
                                                                            style={{ position: 'absolute', top: 50, right: 0, color: 'black' }}
                                                                        >
                                                                            <DescriptionOutlinedIcon />
                                                                        </IconButton>
                                                                    </Tooltip> */}

                                                            <Box style={{ display: 'grid', justifyContent: 'center' }} mb={2}>
                                                                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <Avatar
                                                                        alt="Lead Avatar"
                                                                        src={LeadLogo}
                                                                        sx={{ width: 100, height: 100, mr: 2 }}
                                                                    />
                                                                </Box>
                                                                <Box style={{ marginTop: '10px' }}>
                                                                    <Typography style={{ fontSize: '21px', fontWeight: 'bold' }}>
                                                                        {alert?.lead?.first_name} {alert?.lead?.last_name}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>

                                                            <Box style={{ display: 'grid', gap: '10px' }}>
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <EmailIcon fontSize="small" />
                                                                    <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                                                        {alert?.lead?.email}
                                                                    </Typography>
                                                                </div>
                                                                {alert?.lead?.phone && (
                                                                    <div style={{ display: 'flex', gap: '4px' }}>
                                                                        <PhoneIcon fontSize="small" />
                                                                        <Typography variant="body2"> {alert?.lead?.phone}</Typography>
                                                                    </div>
                                                                )}
                                                                {/* <div style={{ display: 'flex', gap: '4px' }}>
                                                            <LocationOnIcon fontSize="small" />
                                                            <Typography variant="body2">203 Crestview Glen, Escondido, CA 92026, USA</Typography>
                                                        </div> */}
                                                                <Box mt={0}>
                                                                    <Typography
                                                                        sx={{
                                                                            ...divStyle,
                                                                            padding: '2px 5px',
                                                                            borderRadius: '12px',
                                                                            display: 'inline-block',
                                                                            fontSize: '12px',
                                                                        }}
                                                                    >
                                                                        {formattedStatus}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12} md={12}>
                                                            <Divider />
                                                        </Grid>
                                                        {/* Footer Information */}
                                                        <Grid item xs={12} sm={12} md={12}>
                                                            <Box>
                                                                <Grid container spacing={0.5}>
                                                                    <Grid item xs={12} sm={12} md={12}>
                                                                        <div style={{ display: 'flex', gap: '5px' }}>
                                                                            <Avatar
                                                                                sx={{
                                                                                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                                                    bgcolor: '#fff',
                                                                                }}
                                                                            >
                                                                                <DateRangeIcon style={{ color: 'black' }} />
                                                                            </Avatar>
                                                                            <div style={{ marginTop: '10px', display: 'flex', gap: '4px' }}>
                                                                                <Typography style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                                                    Meeting location:
                                                                                </Typography>
                                                                                <Typography style={{ fontSize: '15px' }}>
                                                                                    {alert?.lead?.meeting_location}
                                                                                </Typography>
                                                                            </div>
                                                                        </div>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={12}>
                                                                        <div style={{ display: 'flex', gap: '5px' }}>
                                                                            <Avatar
                                                                                sx={{
                                                                                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                                                    bgcolor: '#fff',
                                                                                }}
                                                                            >
                                                                                <LocationOnIcon style={{ color: 'black' }} />
                                                                            </Avatar>
                                                                            <div style={{ marginTop: '10px', display: 'flex', gap: '4px' }}>
                                                                                <Typography style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                                                    Destination:{' '}
                                                                                </Typography>
                                                                                <Typography style={{ fontSize: '15px' }}>
                                                                                    {alert?.lead?.display_address}
                                                                                </Typography>
                                                                            </div>
                                                                        </div>
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Card>
                                            );
                                        })}

                                {/*  Filter and show admin Half-Bamfam alerts*/}
                                {/* {getNotification?.some(
                                            (alert) => alert?.notify_for === 'admin_confirmation' && alert.halfbamfam.isaagent_id !== null
                                        ) && ( */}
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Box
                                        style={{
                                            marginTop: '10px',
                                            height: '80px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            backgroundColor: 'White',
                                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                            borderRadius: '10px',
                                            padding: '0 16px',
                                        }}
                                    >
                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            <Tooltip
                                                title="Alerts in which agent sets status to BAMFAM and its
                                                         customer was sent a confirmation, but customer didn't confirm."
                                                arrow
                                            >
                                                <InfoIcon style={{ cursor: 'pointer', color: '#1976d2' }} />
                                            </Tooltip>
                                        </Box>

                                        <Box style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
                                            <Typography
                                                style={{
                                                    fontSize: '22px',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                Half-Bamfam Alerts
                                            </Typography>
                                        </Box>
                                        <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            {/* Expand/Collapse Toggle */}
                                            <IconButton onClick={() => setIsOpenHalfBamfam(!isOpenHalfBamfam)}>
                                                {isOpenHalfBamfam ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </IconButton>
                                        </Box>
                                    </Box>
                                </Grid>
                                {/* )} */}

                                {isOpenHalfBamfam &&
                                    getNotification
                                        ?.filter((alert) => alert?.notify_for === 'admin_confirmation' && alert.halfbamfam.isaagent_id !== null)
                                        ?.map((alert) => {
                                            const PreviousDatetime = `${alert?.lead?.date} ${alert?.lead?.time}`;
                                            const NewMeetingDatetime = `${alert?.halfbamfam?.confirmation_date} ${alert?.halfbamfam?.confirmation_time}`;
                                            const userOffset = getUserOffset();
                                            const adjustedDatePrevious = adjustTimeBasedOnOffsetForReceivedData(PreviousDatetime, userOffset);
                                            const adjustedDateNew = adjustTimeBasedOnOffsetForReceivedData(NewMeetingDatetime, userOffset);
                                            const formattedDatePrevious = formatDateTime(adjustedDatePrevious);
                                            const formattedDateNew = formatDateTime(adjustedDateNew);
                                            const { formattedStatus, divStyle } = mapStatusToFormatAndColor(alert?.lead?.status);

                                            return (
                                                <Card
                                                    key={alert?.id}
                                                    sx={{
                                                        width: {
                                                            xs: '100%',
                                                            sm: '47%',
                                                            md: '48%',
                                                        },
                                                        height: 'auto',
                                                        margin: '10px',
                                                        transform: 'scale(1)',
                                                        transition: 'transform 0.3s ease-in-out',
                                                        borderRadius: '16px',
                                                        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                        '&:hover': { transform: 'scale(1.02)' },
                                                        padding: '16px',
                                                        backgroundColor: '#FFFFFF',
                                                        cursor: 'pointer',
                                                    }}
                                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                                                >
                                                    <Grid container spacing={2}>
                                                        {/* Left Section */}
                                                        <Grid item xs={5} sm={5} md={5}>
                                                            <Box style={{ display: 'grid', justifyContent: 'center' }} mb={2}>
                                                                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <Avatar
                                                                        alt={alert?.agent?.name}
                                                                        src={`https://iconnctapp.com/` + alert?.agent?.profile_image}
                                                                        sx={{ width: 100, height: 100, mr: 2 }}
                                                                    />
                                                                </Box>
                                                                <Box style={{ marginTop: '10px' }}>
                                                                    <Typography style={{ fontSize: '21px', fontWeight: 'bold' }}>
                                                                        {alert?.agent?.name} {alert?.agent?.last_name}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                            <Box style={{ display: 'grid', gap: '10px' }}>
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <EmailIcon fontSize="small" />
                                                                    <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                                                        {' '}
                                                                        {alert?.agent?.email}
                                                                    </Typography>
                                                                </div>
                                                                {alert?.agent?.phone && (
                                                                    <div style={{ display: 'flex', gap: '4px' }}>
                                                                        <PhoneIcon />
                                                                        <Typography variant="body2"> {alert?.agent?.phone}</Typography>
                                                                    </div>
                                                                )}
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <LocationOnIcon fontSize="small" />
                                                                    <Typography variant="body2"> {alert.address || ''} </Typography>
                                                                </div>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={2} sm={2} md={2} display="flex" justifyContent="center" alignItems="center">
                                                            <Divider orientation="vertical" flexItem />
                                                        </Grid>
                                                        {/* Right Section */}
                                                        <Grid item xs={5} sm={5} md={5} style={{ position: 'relative' }}>
                                                            <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-10px' }}>
                                                                <Button
                                                                    onClick={() => HandleNavigateToLeadDetails(alert?.lead_id)}

                                                                >
                                                                    View Details
                                                                </Button>
                                                            </Box>
                                                            <Box style={{ display: 'grid', justifyContent: 'center' }} mb={2}>
                                                                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <Avatar
                                                                        alt="Lead Avatar"
                                                                        src={LeadLogo}
                                                                        sx={{ width: 100, height: 100, mr: 2 }}
                                                                    />
                                                                </Box>
                                                                <Box style={{ marginTop: '10px' }}>
                                                                    <Typography style={{ fontSize: '21px', fontWeight: 'bold' }}>
                                                                        {alert?.lead?.first_name} {alert?.lead?.last_name}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>

                                                            <Box style={{ display: 'grid', gap: '10px' }}>
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <EmailIcon fontSize="small" />
                                                                    <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                                                        {alert?.lead?.email}
                                                                    </Typography>
                                                                </div>
                                                                {alert?.lead?.phone && (
                                                                    <div style={{ display: 'flex', gap: '4px' }}>
                                                                        <PhoneIcon fontSize="small" />
                                                                        <Typography variant="body2"> {alert?.lead?.phone}</Typography>
                                                                    </div>
                                                                )}
                                                                {/* <div style={{ display: 'flex', gap: '4px' }}>
                                                            <LocationOnIcon fontSize="small" />
                                                            <Typography variant="body2">203 Crestview Glen, Escondido, CA 92026, USA</Typography>
                                                        </div> */}
                                                                <Box mt={0}>
                                                                    <Typography
                                                                        sx={{
                                                                            ...divStyle,
                                                                            padding: '2px 5px',
                                                                            borderRadius: '12px',
                                                                            display: 'inline-block',
                                                                            fontSize: '12px',
                                                                        }}
                                                                    >
                                                                        {formattedStatus}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12} md={12}>
                                                            <Divider />
                                                        </Grid>
                                                        {/* Footer Information */}
                                                        <Grid item xs={12} sm={12} md={12}>
                                                            <Box>
                                                                <Grid container spacing={0.5}>
                                                                    <Grid item xs={12} sm={12} md={12}>
                                                                        <div style={{ display: 'flex', gap: '5px' }}>
                                                                            <Avatar
                                                                                sx={{
                                                                                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                                                    bgcolor: '#fff',
                                                                                }}
                                                                            >
                                                                                <DateRangeIcon style={{ color: 'black' }} />
                                                                            </Avatar>
                                                                            <div style={{ marginTop: '10px', display: 'flex', gap: '4px' }}>
                                                                                <Typography style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                                                    Meeting Date/Time:
                                                                                </Typography>
                                                                                <Typography style={{ fontSize: '15px' }}>
                                                                                    {formattedDateNew}
                                                                                </Typography>
                                                                            </div>
                                                                        </div>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={12}>
                                                                        <div style={{ display: 'flex', gap: '5px' }}>
                                                                            <Avatar
                                                                                sx={{
                                                                                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                                                    bgcolor: '#fff',
                                                                                }}
                                                                            >
                                                                                <LocationOnIcon style={{ color: 'black' }} />
                                                                            </Avatar>
                                                                            <div style={{ marginTop: '10px', display: 'flex', gap: '4px' }}>
                                                                                <Typography style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                                                    Meeting Location:
                                                                                </Typography>
                                                                                <Typography style={{ fontSize: '15px' }}>
                                                                                    {alert?.halfbamfam?.meeting_location}
                                                                                </Typography>
                                                                            </div>
                                                                        </div>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={12}>
                                                                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '5px' }}>
                                                                            <Typography
                                                                                sx={{
                                                                                    border: '1px solid #3f51b5',
                                                                                    backgroundColor: '#f5f5f5',
                                                                                    padding: '4px 12px',
                                                                                    borderRadius: '12px',
                                                                                    display: 'inline-block',
                                                                                    fontSize: '14px',
                                                                                    color: '#3f51b5',
                                                                                    fontWeight: 500,
                                                                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                                                    textAlign: 'center',
                                                                                    maxWidth: 'fit-content',
                                                                                }}
                                                                            >
                                                                                Customer not accepted
                                                                            </Typography>
                                                                        </div>
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Card>
                                            );
                                        })}

                                {/* Filter and show admin Half Appointment alerts */}
                                {/* {getNotification?.some(
                                            (alert) => alert?.notify_for === 'admin_confirmation_appt' && alert.halfbamfam.isaagent_id !== null
                                        ) && ( */}
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Box
                                        style={{
                                            marginTop: '10px',
                                            height: '80px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            backgroundColor: 'White',
                                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                            borderRadius: '10px',
                                            padding: '0 16px',
                                        }}
                                    >
                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            <Tooltip
                                                title="Alerts in which agent sets status to Appointment Set 
                                                        and its customer was sent a confirmation, but customer didn't confirm."
                                                arrow
                                            >
                                                <InfoIcon style={{ cursor: 'pointer', color: '#1976d2' }} />
                                            </Tooltip>
                                        </Box>

                                        <Box style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
                                            <Typography
                                                style={{
                                                    fontSize: '22px',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                Half Appointment Alerts
                                            </Typography>
                                        </Box>
                                        <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            {/* Expand/Collapse Toggle */}
                                            <IconButton onClick={() => setIsOpenAppointment(!isOpenAppointment)}>
                                                {isOpenAppointment ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </IconButton>
                                        </Box>
                                    </Box>
                                </Grid>
                                {/* )} */}

                                {isOpenAppointment &&
                                    getNotification
                                        ?.filter((alert) => alert?.notify_for === 'admin_confirmation_appt' && alert.halfbamfam.isaagent_id !== null)
                                        ?.map((alert) => {
                                            const PreviousDatetime = `${alert?.lead?.date} ${alert?.lead?.time}`;
                                            const NewMeetingDatetime = `${alert?.halfbamfam?.confirmation_date} ${alert?.halfbamfam?.confirmation_time}`;
                                            const userOffset = getUserOffset();
                                            const adjustedDatePrevious = adjustTimeBasedOnOffsetForReceivedData(PreviousDatetime, userOffset);
                                            const adjustedDateNew = adjustTimeBasedOnOffsetForReceivedData(NewMeetingDatetime, userOffset);
                                            const formattedDatePrevious = formatDateTime(adjustedDatePrevious);
                                            const formattedDateNew = formatDateTime(adjustedDateNew);
                                            const { formattedStatus, divStyle } = mapStatusToFormatAndColor(alert?.lead?.status);

                                            return (
                                                <Card
                                                    key={alert?.id}
                                                    sx={{
                                                        width: {
                                                            xs: '100%',
                                                            sm: '47%',
                                                            md: '48%',
                                                        },
                                                        height: 'auto',
                                                        margin: '10px',
                                                        transform: 'scale(1)',
                                                        transition: 'transform 0.3s ease-in-out',
                                                        borderRadius: '16px',
                                                        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                        '&:hover': { transform: 'scale(1.02)' },
                                                        padding: '16px',
                                                        backgroundColor: '#FFFFFF',
                                                        cursor: 'pointer',
                                                    }}
                                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                                                >
                                                    <Grid container spacing={2}>
                                                        {/* Left Section */}
                                                        <Grid item xs={5} sm={5} md={5}>
                                                            <Box style={{ display: 'grid', justifyContent: 'center' }} mb={2}>
                                                                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <Avatar
                                                                        alt={alert?.agent?.name}
                                                                        src={`https://iconnctapp.com/` + alert?.agent?.profile_image}
                                                                        sx={{ width: 100, height: 100, mr: 2 }}
                                                                    />
                                                                </Box>
                                                                <Box style={{ marginTop: '10px' }}>
                                                                    <Typography style={{ fontSize: '21px', fontWeight: 'bold' }}>
                                                                        {alert?.agent?.name} {alert?.agent?.last_name}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                            <Box style={{ display: 'grid', gap: '10px' }}>
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <EmailIcon fontSize="small" />
                                                                    <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                                                        {' '}
                                                                        {alert?.agent?.email}
                                                                    </Typography>
                                                                </div>
                                                                {alert?.agent?.phone && (
                                                                    <div style={{ display: 'flex', gap: '4px' }}>
                                                                        <PhoneIcon />
                                                                        <Typography variant="body2"> {alert?.agent?.phone}</Typography>
                                                                    </div>
                                                                )}
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <LocationOnIcon fontSize="small" />
                                                                    <Typography variant="body2"> {alert.address || ''} </Typography>
                                                                </div>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={2} sm={2} md={2} display="flex" justifyContent="center" alignItems="center">
                                                            <Divider orientation="vertical" flexItem />
                                                        </Grid>
                                                        {/* Right Section */}
                                                        <Grid item xs={5} sm={5} md={5} style={{ position: 'relative' }}>
                                                            <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-10px' }}>
                                                                <Button
                                                                    onClick={() => HandleNavigateToLeadDetails(alert?.lead_id)}

                                                                >
                                                                    View Details
                                                                </Button>
                                                            </Box>

                                                            <Box style={{ display: 'grid', justifyContent: 'center' }} mb={2}>
                                                                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <Avatar
                                                                        alt="Lead Avatar"
                                                                        src={LeadLogo}
                                                                        sx={{ width: 100, height: 100, mr: 2 }}
                                                                    />
                                                                </Box>
                                                                <Box style={{ marginTop: '10px' }}>
                                                                    <Typography style={{ fontSize: '21px', fontWeight: 'bold' }}>
                                                                        {alert?.lead?.first_name} {alert?.lead?.last_name}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>

                                                            <Box style={{ display: 'grid', gap: '10px' }}>
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <EmailIcon fontSize="small" />
                                                                    <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                                                        {alert?.lead?.email}
                                                                    </Typography>
                                                                </div>
                                                                {alert?.lead?.phone && (
                                                                    <div style={{ display: 'flex', gap: '4px' }}>
                                                                        <PhoneIcon fontSize="small" />
                                                                        <Typography variant="body2"> {alert?.lead?.phone}</Typography>
                                                                    </div>
                                                                )}
                                                                {/* <div style={{ display: 'flex', gap: '4px' }}>
                                                            <LocationOnIcon fontSize="small" />
                                                            <Typography variant="body2">203 Crestview Glen, Escondido, CA 92026, USA</Typography>
                                                        </div> */}
                                                                <Box mt={0}>
                                                                    <Typography
                                                                        sx={{
                                                                            ...divStyle,
                                                                            padding: '2px 5px',
                                                                            borderRadius: '12px',
                                                                            display: 'inline-block',
                                                                            fontSize: '12px',
                                                                        }}
                                                                    >
                                                                        {formattedStatus}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12} md={12}>
                                                            <Divider />
                                                        </Grid>
                                                        {/* Footer Information */}
                                                        <Grid item xs={12} sm={12} md={12}>
                                                            <Box>
                                                                <Grid container spacing={0.5}>
                                                                    <Grid item xs={12} sm={12} md={12}>
                                                                        <div style={{ display: 'flex', gap: '5px' }}>
                                                                            <Avatar
                                                                                sx={{
                                                                                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                                                    bgcolor: '#fff',
                                                                                }}
                                                                            >
                                                                                <DateRangeIcon style={{ color: 'black' }} />
                                                                            </Avatar>
                                                                            <div style={{ marginTop: '10px', display: 'flex', gap: '4px' }}>
                                                                                <Typography style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                                                    Meeting Date/Time:
                                                                                </Typography>
                                                                                <Typography style={{ fontSize: '15px' }}>
                                                                                    {formattedDateNew}
                                                                                </Typography>
                                                                            </div>
                                                                        </div>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={12}>
                                                                        <div style={{ display: 'flex', gap: '5px' }}>
                                                                            <Avatar
                                                                                sx={{
                                                                                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                                                    bgcolor: '#fff',
                                                                                }}
                                                                            >
                                                                                <LocationOnIcon style={{ color: 'black' }} />
                                                                            </Avatar>
                                                                            <div style={{ marginTop: '10px', display: 'flex', gap: '4px' }}>
                                                                                <Typography style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                                                    Meeting Location:
                                                                                </Typography>
                                                                                <Typography style={{ fontSize: '15px' }}>
                                                                                    {alert?.halfbamfam?.meeting_location}
                                                                                </Typography>
                                                                            </div>
                                                                        </div>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={12}>
                                                                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '5px' }}>
                                                                            <Typography
                                                                                sx={{
                                                                                    border: '1px solid #3f51b5',
                                                                                    backgroundColor: '#f5f5f5',
                                                                                    padding: '4px 12px',
                                                                                    borderRadius: '12px',
                                                                                    display: 'inline-block',
                                                                                    fontSize: '14px',
                                                                                    color: '#3f51b5',
                                                                                    fontWeight: 500,
                                                                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                                                    textAlign: 'center',
                                                                                    maxWidth: 'fit-content',
                                                                                }}
                                                                            >
                                                                                Customer not accepted
                                                                            </Typography>
                                                                        </div>
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Card>
                                            );
                                        })}

                                {/*  Filter and show admin changed appointment alerts*/}
                                {/* {getNotification?.some(
                                            (alert) => alert?.notify_for === 'admin_confirmation' && alert.halfbamfam.isaagent_id === null
                                        ) && ( */}
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Box
                                        style={{
                                            marginTop: '10px',
                                            height: '80px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            backgroundColor: 'White',
                                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                            borderRadius: '10px',
                                            padding: '0 16px',
                                        }}
                                    >
                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            <Tooltip title="This notification is triggered when an agent modifies the scheduled time of an existing appointment." arrow>
                                                <InfoIcon style={{ cursor: 'pointer', color: '#1976d2' }} />
                                            </Tooltip>
                                        </Box>

                                        <Box style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
                                            <Typography
                                                style={{
                                                    fontSize: '22px',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                }}
                                            >
                                                Changed Appointment Alerts
                                            </Typography>
                                        </Box>
                                        <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            {/* Expand/Collapse Toggle */}
                                            <IconButton onClick={() => setIsOpenChangedAppointment(!isOpenChangedAppointment)}>
                                                {isOpenChangedAppointment ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </IconButton>
                                        </Box>
                                    </Box>
                                </Grid>
                                {/* )} */}

                                {isOpenChangedAppointment &&
                                    getNotification
                                        ?.filter((alert) => alert?.notify_for === 'admin_confirmation' && alert.halfbamfam.isaagent_id === null)
                                        ?.map((alert) => {
                                            const PreviousDatetime = `${alert?.lead?.date} ${alert?.lead?.time}`;
                                            const NewMeetingDatetime = `${alert?.halfbamfam?.confirmation_date} ${alert?.halfbamfam?.confirmation_time}`;
                                            const userOffset = getUserOffset();
                                            const adjustedDatePrevious = adjustTimeBasedOnOffsetForReceivedData(PreviousDatetime, userOffset);
                                            const adjustedDateNew = adjustTimeBasedOnOffsetForReceivedData(NewMeetingDatetime, userOffset);
                                            const formattedDatePrevious = formatDateTime(adjustedDatePrevious);
                                            const formattedDateNew = formatDateTime(adjustedDateNew);
                                            const { formattedStatus, divStyle } = mapStatusToFormatAndColor(alert?.lead?.status);

                                            return (
                                                <Card
                                                    key={alert?.id}
                                                    sx={{
                                                        width: {
                                                            xs: '100%',
                                                            sm: '47%',
                                                            md: '48%',
                                                        },
                                                        height: 'auto',
                                                        margin: '10px',
                                                        transform: 'scale(1)',
                                                        transition: 'transform 0.3s ease-in-out',
                                                        borderRadius: '16px',
                                                        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                        '&:hover': { transform: 'scale(1.02)' },
                                                        padding: '16px',
                                                        backgroundColor: '#FFFFFF',
                                                        cursor: 'pointer',
                                                    }}
                                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'white')}
                                                >
                                                    <Grid container spacing={2}>
                                                        {/* Left Section */}
                                                        <Grid item xs={5} sm={5} md={5}>
                                                            <Box style={{ display: 'grid', justifyContent: 'center' }} mb={2}>
                                                                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <Avatar
                                                                        alt={alert?.agent?.name}
                                                                        src={`https://iconnctapp.com/` + alert?.agent?.profile_image}
                                                                        sx={{ width: 100, height: 100, mr: 2 }}
                                                                    />
                                                                </Box>
                                                                <Box style={{ marginTop: '10px' }}>
                                                                    <Typography style={{ fontSize: '21px', fontWeight: 'bold' }}>
                                                                        {alert?.agent?.name} {alert?.agent?.last_name}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                            <Box style={{ display: 'grid', gap: '10px' }}>
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <EmailIcon fontSize="small" />
                                                                    <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                                                        {' '}
                                                                        {alert?.agent?.email}
                                                                    </Typography>
                                                                </div>
                                                                {alert?.agent?.phone && (
                                                                    <div style={{ display: 'flex', gap: '4px' }}>
                                                                        <PhoneIcon />
                                                                        <Typography variant="body2"> {alert?.agent?.phone}</Typography>
                                                                    </div>
                                                                )}
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <LocationOnIcon fontSize="small" />
                                                                    <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                                                        {' '}
                                                                        {alert.address || ''}{' '}
                                                                    </Typography>
                                                                </div>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={2} sm={2} md={2} display="flex" justifyContent="center" alignItems="center">
                                                            <Divider orientation="vertical" flexItem />
                                                        </Grid>
                                                        {/* Right Section */}
                                                        <Grid item xs={5} sm={5} md={5} style={{ position: 'relative' }}>
                                                            {/* Positioned IconButton */}
                                                            <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-10px' }}>
                                                                <Button
                                                                    onClick={() => HandleNavigateToLeadDetails(alert?.lead_id)}

                                                                >
                                                                    View Details
                                                                </Button>
                                                            </Box>
                                                            <IconButton
                                                                aria-label="delete"
                                                                color="error"
                                                                style={{ position: 'absolute', top: 30, right: 0 }}
                                                                onClick={() => handleDeletePenalty(alert?.penalty?.id)}
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>

                                                            <Box style={{ display: 'grid', justifyContent: 'center' }} mb={2}>
                                                                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <Avatar
                                                                        alt="Lead Avatar"
                                                                        src={LeadLogo}
                                                                        sx={{ width: 100, height: 100, mr: 2 }}
                                                                    />
                                                                </Box>
                                                                <Box style={{ marginTop: '10px' }}>
                                                                    <Typography style={{ fontSize: '21px', fontWeight: 'bold' }}>
                                                                        {alert?.lead?.first_name} {alert?.lead?.last_name}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>

                                                            <Box style={{ display: 'grid', gap: '10px' }}>
                                                                <div style={{ display: 'flex', gap: '4px' }}>
                                                                    <EmailIcon fontSize="small" />
                                                                    <Typography variant="body2" sx={{ wordBreak: 'break-all' }}>
                                                                        {alert?.lead?.email}
                                                                    </Typography>
                                                                </div>
                                                                {alert?.lead?.phone && (
                                                                    <div style={{ display: 'flex', gap: '4px' }}>
                                                                        <PhoneIcon fontSize="small" />
                                                                        <Typography variant="body2"> {alert?.lead?.phone}</Typography>
                                                                    </div>
                                                                )}
                                                                {/* <div style={{ display: 'flex', gap: '4px' }}>
                                                            <LocationOnIcon fontSize="small" />
                                                            <Typography variant="body2">203 Crestview Glen, Escondido, CA 92026, USA</Typography>
                                                        </div> */}
                                                                <Box mt={0}>
                                                                    <Typography
                                                                        sx={{
                                                                            ...divStyle,
                                                                            padding: '2px 5px',
                                                                            borderRadius: '12px',
                                                                            display: 'inline-block',
                                                                            fontSize: '12px',
                                                                        }}
                                                                    >
                                                                        {formattedStatus}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                        </Grid>

                                                        <Grid item xs={12} sm={12} md={12}>
                                                            <Divider />
                                                        </Grid>
                                                        {/* Footer Information */}
                                                        <Grid item xs={12} sm={12} md={12}>
                                                            <Box>
                                                                <Grid container spacing={0.5}>
                                                                    <Grid item xs={12} sm={12} md={12}>
                                                                        <div style={{ display: 'flex', gap: '5px' }}>
                                                                            <Avatar
                                                                                sx={{
                                                                                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                                                    bgcolor: '#fff',
                                                                                }}
                                                                            >
                                                                                <DateRangeIcon style={{ color: 'black' }} />
                                                                            </Avatar>
                                                                            <div style={{ marginTop: '10px', display: 'flex', gap: '4px' }}>
                                                                                <Typography style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                                                    Previous Meeting Date/Time:
                                                                                </Typography>
                                                                                <Typography style={{ fontSize: '15px' }}>
                                                                                    {formattedDatePrevious}
                                                                                </Typography>
                                                                            </div>
                                                                        </div>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={12}>
                                                                        <div style={{ display: 'flex', gap: '5px' }}>
                                                                            <Avatar
                                                                                sx={{
                                                                                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                                                    bgcolor: '#fff',
                                                                                }}
                                                                            >
                                                                                <LocationOnIcon style={{ color: 'black' }} />
                                                                            </Avatar>
                                                                            <div style={{ marginTop: '10px', display: 'flex', gap: '4px' }}>
                                                                                <Typography style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                                                    Previous Meeting Location:
                                                                                </Typography>
                                                                                <Typography style={{ fontSize: '15px' }}>
                                                                                    {alert?.lead?.meeting_location}
                                                                                </Typography>
                                                                            </div>
                                                                        </div>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={12}>
                                                                        <div style={{ display: 'flex', gap: '5px' }}>
                                                                            <Avatar
                                                                                sx={{
                                                                                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                                                    bgcolor: '#fff',
                                                                                }}
                                                                            >
                                                                                <DateRangeIcon style={{ color: 'black' }} />
                                                                            </Avatar>
                                                                            <div style={{ marginTop: '10px', display: 'flex', gap: '4px' }}>
                                                                                <Typography style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                                                    New Meeting Date/Time:
                                                                                </Typography>
                                                                                <Typography style={{ fontSize: '15px' }}>
                                                                                    {formattedDateNew}
                                                                                </Typography>
                                                                            </div>
                                                                        </div>
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={12} md={12}>
                                                                        <div style={{ display: 'flex', gap: '5px' }}>
                                                                            <Avatar
                                                                                sx={{
                                                                                    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                                                                                    bgcolor: '#fff',
                                                                                }}
                                                                            >
                                                                                <LocationOnIcon style={{ color: 'black' }} />
                                                                            </Avatar>
                                                                            <div style={{ marginTop: '10px', display: 'flex', gap: '4px' }}>
                                                                                <Typography style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                                                    New Meeting Location:
                                                                                </Typography>
                                                                                <Typography style={{ fontSize: '15px' }}>
                                                                                    {alert?.halfbamfam?.meeting_location}
                                                                                </Typography>
                                                                            </div>
                                                                        </div>
                                                                    </Grid>
                                                                </Grid>
                                                                <Typography
                                                                    variant="body2"
                                                                    textAlign="right"
                                                                    color="primary"
                                                                    mt={2}
                                                                    fontWeight="bold"
                                                                >
                                                                    Created Alert: ICA
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Card>
                                            );
                                        })}
                            </>
                            {/* )} */}
                        </Grid>
                    </>
                    {/* )} */}
                </>
                <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
            </Container>
            {/*Alerts delete modal */}
            <Modal open={openDialog} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <div style={{ marginTop: '20px', position: 'relative' }}>
                        <Box
                            sx={{
                                display: 'grid',
                                padding: '10px',
                                gap: '10px',
                            }}
                        >
                            <Box style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                <Box>
                                    <CancelIcon style={{ fontSize: '34px' }} />
                                </Box>
                                <Box style={{ display: 'grid', gap: '10px' }}>
                                    <div>
                                        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Are you sure you want to delete this Alert?</span>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: '16px', color: '#252F46' }}>
                                            This action will delete this alert permanently, and you can not undo this.
                                        </span>
                                    </div>
                                </Box>
                            </Box>
                        </Box>

                        <Box style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            <Button
                                onClick={handleClickClose}
                                style={{
                                    width: '140px',
                                    height: '43px',
                                    backgroundColor: 'white',
                                    fontWeight: '500',
                                    borderRadius: '4px',
                                    border: ' 1px solid #587DBF',
                                    color: '#252F46',
                                    fontSize: '15px',
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={() => handlePromptMessageDeleted(deletedId)}
                                style={{
                                    width: '140px',
                                    height: '43px',
                                    backgroundColor: '#5379BD',
                                    fontWeight: '500',
                                    borderRadius: '4px',
                                    border: ' 1px solid #587DBF',
                                    color: 'white',
                                    fontSize: '15px',
                                }}
                                disabled={deleteLoading}
                            >
                                {deleteLoading ? 'Deleting...' : 'Delete'}
                                {deleteLoading && <CircularProgress sx={{ visibility: deleteLoading ? '' : 'hidden' }} />}
                            </Button>
                        </Box>
                    </div>
                </Box>
            </Modal>

            {/*Penalty delete modal */}
            <Modal open={openDialogPenalty} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <div style={{ marginTop: '20px', position: 'relative' }}>
                        <Box
                            sx={{
                                display: 'grid',
                                padding: '10px',
                                gap: '10px',
                            }}
                        >
                            <Box style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                <Box>
                                    <CancelIcon style={{ fontSize: '34px' }} />
                                </Box>
                                <Box style={{ display: 'grid', gap: '10px' }}>
                                    <div>
                                        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Are you sure you want to delete this Penalty?</span>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: '16px', color: '#252F46' }}>
                                            This action will delete this Penalty permanently, and you can not undo this.
                                        </span>
                                    </div>
                                </Box>
                            </Box>
                        </Box>

                        <Box style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            <Button
                                onClick={handleClickClose}
                                style={{
                                    width: '140px',
                                    height: '43px',
                                    backgroundColor: 'white',
                                    fontWeight: '500',
                                    borderRadius: '4px',
                                    border: ' 1px solid #587DBF',
                                    color: '#252F46',
                                    fontSize: '15px',
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={() => handlePenaltyDeleted(deletedPenaltyId)}
                                style={{
                                    width: '140px',
                                    height: '43px',
                                    backgroundColor: '#5379BD',
                                    fontWeight: '500',
                                    borderRadius: '4px',
                                    border: ' 1px solid #587DBF',
                                    color: 'white',
                                    fontSize: '15px',
                                }}
                                disabled={deleteLoading}
                            >
                                {deleteLoading ? 'Deleting...' : 'Delete'}
                                {deleteLoading && <CircularProgress sx={{ visibility: deleteLoading ? '' : 'hidden' }} />}
                            </Button>
                        </Box>
                    </div>
                </Box>
            </Modal>
        </>
    );
};
export default ICAAlerts;
